/** Lowercase without accents: "Panadería" -> "panaderia". */
export function foldText(value) {
    return String(value ?? '')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase();
}

/** The visible text of a Select option: its `label`, or its children for `<Option>` elements. */
function optionText(option) {
    const text = option?.label ?? option?.children;
    return Array.isArray(text) ? text.join('') : text;
}

/**
 * Props that make an Ant Design Select searchable by its options' text, ignoring case and
 * accents. Spread them on the Select: `<Select {...searchableSelect} options={...} />`.
 */
export const searchableSelect = Object.freeze({
    showSearch: true,
    filterOption: (input, option) => foldText(optionText(option)).includes(foldText(input).trim()),
});
